<div class="filters-bar" [class.client-filters]="role === 'client'">
	<mat-card class="mt-0" id="tag-dropzone-filter">
		<mat-card-content class="p-0">
			<div class="d-flex flex-wrap align-items-center justify-contents-start mx-1">
				<form #filtersFormDirective="ngForm" [formGroup]="filtersFormGroup" class="mt-2 flex-fill d-flex flex-wrap" (submit)="filterListItems()">
					<!-- Client transcriptions filters: type + language hidden (read-only view). @if (false) used because @for can't be HTML-commented. -->
					@if (false) {
					<mat-form-field class="ms-1 w-100">
						<mat-label>{{ 'TRANSCRIPTIONS.TYPE' | translate }}</mat-label>
						<select id="types" style="display: none"></select>
						<!-- workaround for material-chrome bug -->
						<mat-select id="transcriptionTypes" formControlName="types" multiple>
							<mat-option #selectAllTranscriptionTypes value="ALL" (click)="transcriptionTypeSelection()">{{ 'TRANSCRIPTIONS.TYPES.ALL' | translate }}</mat-option>

							@for (transcriptionType of transcriptionTypes; track $index) {
							<mat-option [value]="transcriptionType.id" (click)="transcriptionTypeSelection($event)">{{ 'TRANSCRIPTIONS.TYPES.' + transcriptionType.id | translate }}</mat-option>
							}
						</mat-select>
					</mat-form-field>

					<mat-form-field class="ms-1" [ngClass]="{ 'w-100': role === 'client' }">
						<mat-label>{{ 'TRANSCRIPTIONS.LANG' | translate }}</mat-label>
						<select id="langs" style="display: none"></select>
						<!-- workaround for material-chrome bug -->
						<mat-select id="transcriptionLangs" formControlName="langs" multiple>
							@for (transcriptionLang of transcriptionLangs; track transcriptionLang.id) {
								<mat-option [value]="transcriptionLang.id">
									{{ 'TRANSCRIPTIONS.LANGS.' + transcriptionLang.id | translate }}
								</mat-option>
							}
						</mat-select>
					</mat-form-field>
					}

					<mat-form-field class="ms-1 w-100">
						<mat-date-range-input [rangePicker]="picker" color="primary" [max]="DATE_RANGE_LIMITS.dateTo">
							<input id="dateFrom" formControlName="createdAtFrom" matStartDate placeholder="{{ 'TRANSCRIPTIONS.DATE_FROM' | translate }}" />
							<input id="dateTo" formControlName="createdAtTo" matEndDate placeholder="{{ 'TRANSCRIPTIONS.DATE_TO' | translate }}" [value]="getDateLimitRange()" />
						</mat-date-range-input>
						<mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
						<mat-date-range-picker #picker>
							<mat-date-range-picker-actions>
								<button mat-button matDateRangePickerCancel>{{ 'BUTTON.CANCEL' | translate }}</button>
								<button mat-raised-button color="primary" matDateRangePickerApply>{{ 'BUTTON.APPLY' | translate }}</button>
							</mat-date-range-picker-actions>
						</mat-date-range-picker>
					</mat-form-field>

					<!-- Client transcriptions filters: file name + speaker hidden (read-only view).
					<mat-form-field class="ms-1 flex-fill">
						<mat-label>{{ 'TRANSCRIPTIONS.FILE_NAME' | translate }}</mat-label>
						<input matInput formControlName="fileName" placeholder="" />
					</mat-form-field>

					<mat-form-field class="ms-1 flex-fill">
						<mat-label>{{ 'TRANSCRIPTIONS.SPEAKER' | translate }}</mat-label>
						<input matInput formControlName="speaker" placeholder="" />
					</mat-form-field>
					-->

					<div class="ms-1 d-flex mb-2 align-items-center w-100" [class.justify-content-between]="role !== 'client'">
						<button
							type="button"
							mat-raised-button
							color="primary"
							class="me-1"
							aria-label="Reset form button"
							matTooltip="{{ 'TRANSCRIPTIONS.RESET_FORM' | translate }}"
							matTooltipPosition="below"
							(click)="resetForm(filtersFormDirective)">
							<mat-icon class="m-0">restart_alt</mat-icon>
						</button>

						<button type="submit" mat-raised-button [color]="filtersActive ? 'warn' : 'primary'" class="me-1" aria-label="Filter button" [disabled]="apiLoading">
							@if(apiLoading) {
							<mat-spinner diameter="20"></mat-spinner>
							} @else {
							<span>{{ 'BUTTON.SHOW' | translate }}</span>
							}
						</button>

						@if (role !== 'client') {
						<div class="d-flex">
							<button
								type="button"
								mat-raised-button
								[color]="isRecording ? 'warn' : 'primary'"
								class="me-1"
								aria-label="Record audio button"
								[matTooltip]="isRecording ? ('TRANSCRIPTIONS.STOP_RECORDING' | translate) + ' (' + recordingDuration + ')' : ('TRANSCRIPTIONS.RECORD_AUDIO' | translate)"
								matTooltipPosition="below"
								[disabled]="isProcessingRecording"
								(click)="toggleRecording()">
								@if(isProcessingRecording) {
									<mat-spinner diameter="20"></mat-spinner>
								} @else {
									<mat-icon>{{ isRecording ? 'voice_over_off' : 'record_voice_over' }}</mat-icon>
								}
							</button>

							<button
								type="button"
								mat-raised-button
								color="primary"
								class="me-1"
								aria-label="Create transcription button"
								matTooltip="{{ 'TRANSCRIPTIONS.TRANSCRIBE' | translate }}"
								matTooltipPosition="below"
								(click)="openCreateTranscriptionDialog()">
								<mat-icon>upload</mat-icon>
							</button>
						</div>
						}
					</div>
				</form>
			</div>
			<mat-divider class="w-100"></mat-divider>
		</mat-card-content>
	</mat-card>
</div>